import schema from './question_schema';

const hydrateQuestions = (simplified) => {
  const detailed = {};

  for (const [key, value] of Object.entries(simplified)) {
    if (!schema[key]) continue; // skip unknown keys

    const {fieldType, options} = schema[key];

    detailed[key] = {
      bioQuestionId: key,
      fieldType,
      questionData: {},
    };

    if (options) {
      detailed[key].questionData.options = options;
    }

    // Value handling based on type
    if (fieldType === 'multi_select' && Array.isArray(value)) {
      detailed[key].questionData.value = value;
    } else if (fieldType === 'five_star') {
      detailed[key].questionData.value = Number(value);
    } else if (fieldType === 'checkbox') {
      detailed[key].questionData.value = Boolean(value);
    } else {
      detailed[key].questionData.value = value;
    }
  }

  return detailed;
};

export default hydrateQuestions;
